import Login from "@/components/login/"
import { validate } from "@/util/form-validate.js";
import PasswordRules from "@/components/login/passwordRegistration/PasswordRules.vue";

export default {
  name: "password-recover",

  components: {
    Login,
    PasswordRules,
  },

  data: (vm) => ({
    show1: false,
    show2: false,
    dialogRecover: true,
    validRecover: true,
    loading: false,
    passwordConfirm: "",
    recover: {
      hash: "",
      password: "",
    },
    rules: {
      required: validate.required,
    },
    passwordRules: {
      oneLowercaseLetter: {
        error: true,
        message: "firstPasswordRegistration.rules.oneLowerAndUppercaseLetter",
        validate: (v) => /(?=.*?[a-z])/.test(v) && /(?=.*?[A-Z])/.test(v),
      },
      oneNumber: {
        error: true,
        message: "firstPasswordRegistration.rules.oneNumber",
        validate: (v) => /(?=.*?[0-9])/.test(v),
      },
      oneSpecialCharacter: {
        error: true,
        message: "firstPasswordRegistration.rules.oneSpecialCharacter",
        validate: (v) => /(?=.*?[#?!@$%^&*-])/.test(v),
      },
      betweenEightAndTwelveCharacters: {
        error: true,
        message: "firstPasswordRegistration.rules.betweenEightAndTwelveCharacters",
        validate: (v) => v.length >= 8 && v.length <= 12,
      },
      onfirmation: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.confirmation"),
        validate: () =>
          vm.recover.password && vm.passwordConfirm
            ? vm.recover.password === vm.passwordConfirm
            : false,
      },
    },
    // Success Callback
    vCardFormRecover: true,
    msgSuccess: "",
  }),

  mounted() {
    this.recover.hash = this.$route.params.hash;
  },

  computed: {
    passMatch() {
      let required = this.$t("required");
      let repeatPassWord = this.$t("repeatThePassword");

      const rules = [
        // Required
        (v) => !!v || required,
      ];

      // Confirm Password
      if (this.passwordConfirm) {
        const rule =
          (v) => (!!v && v) === this.recover.password || repeatPassWord;
        rules.push(rule);
      }

      return rules;
    },
  },

  watch: {
    dialogRecover(val) {
      !val && this.$router.push("/");
    },
    "recover.password"(password) {
      if (password == null || password == "") return;

      this.checkPasswordRules();
    },
  },

  methods: {
    passRecover() {
      if (!this.$refs.formRecover.validate()) return;

      this.loading = true;

      this.$axios
        .post("player/register/resetPassword", this.$formdata(this.recover))
        .then(resp => {
          this.$Progress.start();

          this.vCardFormRecover = false;
          this.msgSuccess = resp.data.messages;
          const color = "success";
          this.$store.commit("setNotification", {
            msg: this.msgSuccess,
            color,
          });

          this.$login(resp.data.dados.login, this.recover.password)
            .then((res) => {
              this.$store.commit("setNotification", {
                msg: res.message,
                color: "green",
              });

              this.$Progress.finish();
              this.$router.push("/");
            })
            .catch((err) => {
              this.$store.commit("setNotification", {
                msg: err.response.data.messages.error,
                color: "warning",
              });

              this.$Progress.fail();
            });
        })
        .catch(error => {
          const msg = error.response.data.messages[0];
          const color = "warning";

          this.$store.commit("setNotification", {
            msg,
            color,
          });
        })
        .finally(() => {
          this.loading = false;
          this.$store.state.showMigrationUserLoginMessage = false;
        });
    },
    checkPasswordRules() {
      if (this.recover.password.length == 0) return false;

      let allRulesChecked = true;

      for (const rule in this.passwordRules) {
        this.passwordRules[rule].error =
          this.passwordRules[rule].validate(
            this.recover.password ? this.recover.password : ""
          ) === false;

        if (this.passwordRules[rule].error) allRulesChecked = false;
      }

      return allRulesChecked;
    },
  },
}